import React from "react";
import { FiPaperclip, FiSend } from "react-icons/fi";
import { PLACEHOLDER } from "./copy";

// The message box. 16 px text so iPhones do not zoom in on focus; Enter sends.
export default function Composer({ value, onChange, onSend, onToggleUpload, fileInputRef, onFileChange }) {
  return (
    <form
      className="rg-composer"
      onSubmit={(e) => {
        e.preventDefault();
        onSend();
      }}
    >
      {onToggleUpload && (
        <>
          <input ref={fileInputRef} type="file" multiple hidden onChange={onFileChange} accept="image/*,.pdf,.doc,.docx,.txt" />
          <button type="button" className="rg-icon-btn" aria-label="Attach a file" onClick={onToggleUpload}>
            <FiPaperclip size={18} />
          </button>
        </>
      )}
      <input
        className="rg-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={PLACEHOLDER}
        aria-label="Message Rigby"
        enterKeyHint="send"
        autoComplete="off"
      />
      <button type="submit" className="rg-send" aria-label="Send message">
        <FiSend size={18} />
      </button>
    </form>
  );
}
